import UserBus from '../utils/buses/UserBus'
import MessageBus from '../utils/buses/MessageBus'

export const editProfileGuard = (to, from, next) => {
    // if token has expired, redirect to login page
    if (UserBus.tokenHasExpired()) {
        // TODO - store users last logged in page so they can return after logging back in
        MessageBus.sendMessage('Your authentication has expired. Please log in', 'info')
        next({ name: 'login' })
        return
    }

    const token = UserBus.token

    const decoded = UserBus.decodeToken(token)

    if (
        decoded
        && decoded.user
        && decoded.user.verified === false
    ) {
        next({ name: 'verifyEmail' })
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && !decoded.user.handle
    ) {
        next({ name: 'chooseHandle' })
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && decoded.user.handle
        && decoded.user.handle.toLowerCase() === to.params.handle.toLowerCase()
    ) {
        next()
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && decoded.user.handle
        && decoded.user.handle.toLowerCase() !== to.params.handle.toLowerCase()
    ) {
        next({ name: 'notAuthorized' })
    } else {
        next({ name: 'login' })
    }
}

export const verifyEmailGuard = (to, from, next) => {
    // if token has expired, redirect to login page
    if (UserBus.tokenHasExpired()) {
        // TODO - store users last logged in page so they can return after logging back in
        MessageBus.sendMessage('Your authentication has expired. Please log in', 'info')
        next({ name: 'login' })
        return
    }
    const token = UserBus.token

    const decoded = UserBus.decodeToken(token)

    if (
        decoded
        && decoded.user
        && decoded.user.verified === false
    ) {
        next()
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && !decoded.user.handle
    ) {
        next({ name: 'chooseHandle' })
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && decoded.user.handle
    ) {
        MessageBus.sendMessage('Your account has already been set up. Navigating to edit profile page.', 'info')
        next({
            name: 'profile',
            params: {
                handle: decoded.user.handle
            }
        })
    } else {
        next({ name: 'signUp' })
    }
}

export const chooseHandleGuard = (to, from, next) => {
    // if token has expired, redirect to login page
    if (UserBus.tokenHasExpired()) {
        // TODO - store users last logged in page so they can return after logging back in
        MessageBus.sendMessage('Your authentication has expired. Please log in', 'info')
        next({ name: 'login' })
        return
    }
    const token = UserBus.token

    const decoded = UserBus.decodeToken(token)

    if (
        decoded
        && decoded.user
        && decoded.user.verified === false
    ) {
        next({ name: 'verifyEmail' })
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && !decoded.user.handle
    ) {
        next()
    } else if (
        decoded
        && decoded.user
        && decoded.user.verified === true
        && decoded.user.handle
    ) {
        MessageBus.sendMessage('Your account has already been set up. Navigating to edit profile page.', 'info')
        next({
            name: 'profile',
            params: {
                handle: decoded.user.handle
            }
        })
    } else {
        next({ name: 'signUp' })
    }
}
